/* eslint-disable angular/factory-name */

angular.
module("dx.webapp.roles").
factory("Role", function DxRoleFactory(
	$http,
	RoleTypeEnum
) {
	"use strict";

	function Role(data) {
		var dirty = false;
		angular.extend(this, {
			// Role properties
			id: 0,
			title: "",
			userIds: [],
			organizationId: 0,
			organizationTitle: "",
			roleType: RoleTypeEnum.PUB,
			roleKey: "",
			displayName: "",
			isFreemium: false,

			// Public functions

			isDirty: function isDirty() {
				return dirty;
			},

			setDirty: function setDirty(state) {
				dirty = state;
				return dirty;
			},

			revoke: function revoke(userId) {
				var self = this;
				for (var i = 0; i < self.userIds.length; i++) {
					var id = self.userIds[i];
					if (id === userId) {
						self.userIds.splice(i, 1);
					}
				}
				return self.save();
			},

			save: function save() {
				return $http.post("/node/role/save/", this).then(function success(response) {
					return response.data;
				});
			},
		});

		if (data) {
			data.userIds = data.userIds ? data.userIds : [];
			angular.extend(this, data);
		}
	}

	return Role;
});
